//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'ExcretionFraction_Ca',
  data() {
    return {
      defaultJson:{
        "Blood calcium": "血钙",
        "Pl Creatinine": "血肌酐",
        "Urinary calcium": "尿钙",
        "U Creatinine": "尿肌酐"
      },
      form:{
        blood_calcium:'',
        creatinine:'',
        urinary_calcium:'',
        ucreat:'',
      },
      hasScore:false,
      disabled:false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key]=='---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        console.log(form)
        // 排泄分数（钙）=（尿Ca*血Cr）/（血Ca*尿Cr）
        let result = (form.urinary_calcium * form.creatinine) / (form.blood_calcium * form.ucreat)
        console.log(result)
        self.hasScore = true
        return String((result*100).toFixed(2))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Renal/ExcretionFraction_Ca.vue